/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import _ from 'lodash';
import can from 'can';
import BaseWidget from 'scripts/base-widget';
import 'components/contact-us/contact-us';
import RequiredValidator from 'scripts/validators/required-validator';
import EmailValidator from 'scripts/validators/email-validator';

export const ContactUs = BaseWidget.extend({
    init() {
        const options = this.options.data || {};
        const requiredValidator = new RequiredValidator(
            options.requiredMessage,
        );
        const emailValidator = new EmailValidator(options.emailErrorMessage);

        this.viewModel = {
            faq: {
                title: options.faqTitle,
                destination: options.faqDestination,
                newWindow: options.faqNewWindow,
            },
            formOptions: {
                action: options.action,
                thanksMessage: options.thanksMessage,
            },
            defaultEmailAddr: options.defaultEmailAddr,
            fields: {
                fullName: {
                    validators: [].concat(
                        options.firstNameRequired ? requiredValidator : [],
                    ),
                },
                email: {
                    validators: [].concat(
                        emailValidator,
                        options.emailRequired ? requiredValidator : [],
                    ),
                },
                country: {
                    validators: [].concat(
                        options.countryRequired ? requiredValidator : [],
                    ),
                },
                subject: {
                    properties: options.subjectProperties,
                    validators: [].concat(
                        options.subjectRequired ? requiredValidator : [],
                    ),
                },
                message: {
                    length: options.messageSize,
                    validators: [].concat(
                        options.msgRequired ? requiredValidator : [],
                    ),
                },
            },
        };
        this.view = can.stache(
            '<contact-us {form-options}="formOptions" {faq}="faq" {fields}="fields" default-email-addr="{{defaultEmailAddr}}"></contact-us>',
        );
        this._super();
    },
});
